import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Approach", href: "#about" },
  { label: "Work", href: "#work" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 backdrop-blur-md border-b border-white/10 ${
        scrolled ? "bg-[#1A1A1A]/85" : "bg-[#1A1A1A]/45"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-brand"
          aria-label="Sanya Vithalkar, home"
          className="font-serif text-2xl sm:text-3xl font-semibold tracking-tight text-white flex items-center gap-2.5"
        >
          <span className="inline-block w-2.5 h-2.5 rounded-full bg-[#6B8F71]" />
          Sanya Vithalkar
        </a>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-sans text-sm tracking-wide text-white/90 hover:text-[#C9A24B] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#C9A24B] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-[#1A1A1A]/95 backdrop-blur-md border-b border-white/10 px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="font-sans text-base text-white py-1"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;
